export default function SafetySection() {
  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="bg-amber-50/60 border border-amber-200/60 rounded-lg p-6 md:p-8">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-200 text-amber-700 flex-shrink-0">
              <i className="ri-information-line text-lg"></i>
            </div>
            <div>
              <h2 className="font-heading text-xl font-semibold text-amber-900 mb-3">
                Important Notice
              </h2>
              <p className="text-sm text-amber-800 leading-relaxed">
                All content on this website is for <strong>informational and educational purposes only</strong>.
                We do not sell products directly. Users should always verify suppliers independently and comply
                with local import regulations before making any purchase decisions. The AllChinaBuySpreadsheet
                is a data aggregation tool and does not guarantee product quality or supplier reliability.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}